export const CHOICE = {
  YES: 'YES',
  NO: 'NO',
};
export const LABEL_WIDTH = 60;
export const MAX_LENGTH = 200;

export const registrationPatterns: Record<
  number,
  { regex: RegExp; format: string }
> = {
  1: { regex: /^\d{1,5}-[A-Z]{1}-\d{1,2}$/, format: '99999-A-99' },
  2: { regex: /^WW \d{1,6}$/, format: 'WW 999999' },
  3: { regex: /^\d{1,2}-\d{1,6}$/, format: '99-999999' },
  4: { regex: /^\d{1,4}-\d{1,2}-\d{1,2}$/, format: '9999-99-99' },
  5: { regex: /^\d{1,4}-\d{1,2}$/, format: '9999-99' },
};
